import { render } from "./Up.vue?vue&type=template&id=84101322&scoped=true"
import script from "./Up.vue?vue&type=script&lang=js"
export * from "./Up.vue?vue&type=script&lang=js"

import "./Up.vue?vue&type=style&index=0&id=84101322&scoped=true&lang=css"

import exportComponent from "/opt/stagecoach/apps/pa-wildflower-selector/deployments/2022-05-18-09-54-08/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84101322"]])

export default __exports__